import React from 'react';
import shallowCompare from '../../lib/shallowCompare';
import DelectableRating from '../DelectableRating';
import ProBadgePng from '../images/pro_badge.png';
import ProBadgeSvg from '../images/pro_badge.svg';
import styles from './index.sass';

class ProductReview extends React.Component {
  static propTypes = {
    review: React.PropTypes.object.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let { review } = this.props;
    let proBadge;
    let rating = review.rating;
    if(rating) {
      let delectableRatingProps = {
        rating: rating,
        className: styles.ratingBadge
      };
      rating = <DelectableRating {...delectableRatingProps} />;
    }

    if(review.reviewer_is_influencer) {
      proBadge = <img src={ProBadgePng} srcSet={ProBadgeSvg} alt="Delectable Pro" />;
    }

    return (
      <div className={styles.review}>
        <img className={styles.photo} src={review.reviewer_photo_hash.getClosestToTarget(120)} />
        <div className={styles.details}>
          <p className={styles.reviewerName}>{review.reviewer_name} {proBadge}</p>
          {review.reviewer_title ? <p className={styles.reviewerTitle}>{review.reviewer_title}</p> : null}
          <p className={`${styles.reviewText} ${styles.showOnDesktop}`}>{review.review}</p>
        </div>
        <p className={`${styles.reviewText} ${styles.showOnMobile}`}>{review.review}</p>
        {rating}
      </div>
    );
  }
}

export default ProductReview;



// WEBPACK FOOTER //
// banquet/components/ProductReview/index.js